var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTenant = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M2.5 8.804c0-.478 0-.718.062-.938.054-.195.144-.379.265-.542.136-.184.325-.33.702-.625l5.652-4.396c.293-.227.44-.341.601-.385a.83.83 0 0 1 .436 0c.161.044.308.158.6.385L16.472 6.7c.377.294.566.441.702.625.12.163.21.347.265.542.062.22.062.46.062.938v6.03c0 .933 0 1.4-.182 1.756-.16.314-.414.569-.728.729-.357.181-.823.181-1.757.181H5.167c-.934 0-1.4 0-1.757-.181a1.67 1.67 0 0 1-.728-.729c-.182-.356-.182-.823-.182-1.757z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTenant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tenant.63b1b559.svg";
export { ForwardRef as ReactComponent };